import { render, staticRenderFns } from "./AddHorseCroissance.vue?vue&type=template&id=862f42e2&"
import script from "./AddHorseCroissance.vue?vue&type=script&lang=js&"
export * from "./AddHorseCroissance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports